<template>
  <LoadOnVisible v-on:intersected="loadChartData" ref="chartSection" id="ChartInventoryStatusCards">
    <b-row>
      <div class="col-12 col-sm-4">
        <button class="w-100 d-block card bg-danger text-high-emphasis-inverse mb-4 pb-3 text-left" @click="OpenWarehouseProdsFor(2)">
          <div class="card-body pb-0 d-flex justify-content-between align-items-start">
            <div>
              <h4 class="fs-4 fw-semibold"><i class="fa fa-tags mr-1"></i> {{chartInfoView.itemsWarning + chartInfoView.itemsUrgent}} <span class="fs-6 fw-normal"><i>- Urgent</i> </span>
              </h4>
              <div class="pt-2 pb-1">
                <h6>Items expected to be out of VERY soon.</h6>
              </div>
            </div>
            <div class="btn-group">
            </div>
          </div>
          <!---->
        </button>
      </div>
      <div class="col-12 col-sm-4">
        <button class="w-100 d-block card bg-warning text-high-emphasis-inverse mb-4 pb-3 text-left" @click="OpenWarehouseProdsFor(1)">
          <div class="card-body pb-0 d-flex justify-content-between align-items-start">
            <div>
              <h4 class="fs-4 fw-semibold"><i class="fa fa-tags mr-1"></i> {{chartInfoView.itemsNotice}} <span class="fs-6 fw-normal"><i>- Warning</i> </span>
              </h4>
              <div class="pt-2 pb-1">
                <h6>Items expected to be out of soon enough.</h6>
              </div>
            </div>
            <div class="btn-group">
            </div>
          </div>
          <!---->
        </button>
      </div>
      <div class="col-12 col-sm-4">
        <button class="w-100 d-block card bg-success text-high-emphasis-inverse mb-4 pb-3 text-left" @click="OpenWarehouseProdsFor(0)">
          <div class="card-body pb-0 d-flex justify-content-between align-items-start">
            <div>
              <h4 class="fs-4 fw-semibold"><i class="fa fa-tags mr-1"></i> {{chartInfoView.itemsNormal}} <span class="fs-6 fw-normal"><i>- Normal</i> </span>
              </h4>
              <div class="pt-2 pb-1">
                <h6>Items have enough inventory to last a while.</h6>
              </div>
            </div>
            <div class="btn-group">
            </div>
          </div>
          <!---->
        </button>
      </div>
    </b-row>
  </LoadOnVisible>
</template>

<script>
import LoadOnVisible from '@/views/components/LoadOnVisible.vue';
export default {
  components: {
    LoadOnVisible
  },
  data: () => {
    return {
      isLoadingChartData: true,
      chartInfoView: {
        items: [],
        itemsNormal: 0,
        itemsNotice: 0,
        itemsWarning: 0,
        itemsUrgent: 0,
      }
    }
  },
  methods: {
    OpenWarehouseProdsFor(stateId) {
      this.$router.push({
        name: 'Warehouses.Items',
        query: { inventoryStatus: stateId }
      });
    },
    loadChartData() {
      this.isLoadingChartData = true;
      this.$http
        .post('/api/common/analytics/inventory-status-summary', {})
        .then(resp => {
          this.isLoadingChartData = false;
          this.chartInfoView = resp.data;
        })
        .catch(err => {
          this.isLoadingChartData = false;
          this.chartInfoView = {
            items: [],
            itemsNormal: 0,
            itemsNotice: 0,
            itemsWarning: 0,
            itemsUrgent: 0,
          }
        });
    }
  },
  mounted() {
  }
}
</script>

<style>

</style>
